module.exports = __webpack_public_path__ + "static/favicon-0d086d6dc2b7e3bbddcbfe15f7d98c56.ico";